"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var _default = function _default(_ref) {
  var className = _ref.className,
      appkey = _ref.appkey,
      domain = _ref.domain,
      productId = _ref.productId,
      productModels = _ref.productModels,
      name = _ref.name,
      url = _ref.url,
      imageUrl = _ref.imageUrl,
      description = _ref.description,
      breadCrumbs = _ref.breadCrumbs,
      linkHref = _ref.linkHref,
      linkTarget = _ref.linkTarget;
  var yotpo = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: className,
    "data-appkey": appkey,
    "data-domain": domain,
    "data-product-id": productId,
    "data-product-models": productModels,
    "data-name": name,
    "data-url": url,
    "data-image-url": imageUrl,
    "data-description": description,
    "data-bread-crumbs": breadCrumbs,
    "data-testid": "creditcardcard:yotpo"
  });
  return linkHref != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Link, {
    target: linkTarget,
    href: linkHref,
    "data-testid": "creditcardcard:yotpolink",
    children: yotpo
  }) : yotpo;
};

exports["default"] = _default;
//# sourceMappingURL=yotpo.js.map